export interface NormalizedAsset {
  productName?: string;
  name?: string;
  type: string;
}
